if (process.env.REACT_APP_END_PLATFORM === 'desktop') {
  require('typeface-montserrat');
} else {
  require('./montserrat.css');
}
